import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { getWidth, getHeight } from '@scale/shared/annotation';
import Slider from 'design-system/Slider';
import { AnnotationAttributeType } from '@scale/shared/defaults';
import { convertNumberInput } from './utils';
import { Caption } from 'design-system';

type XYLineInputProps = {
  attrType: AnnotationAttributeType.XLine | AnnotationAttributeType.YLine;
  annotation: $FIXME;
  attrKey: string;
  selectedChoice: $FIXME;
  handleUpdateSelection: $FIXME;
};

const XYLineInput = (props: XYLineInputProps) => {
  const { attrType, annotation, attrKey, selectedChoice, handleUpdateSelection } = props;

  if (!annotation) {
    return null;
  }

  const max =
    attrType === AnnotationAttributeType.XLine
      ? getWidth(annotation) || 1
      : getHeight(annotation) || 1;

  const position = (convertNumberInput(selectedChoice) || 0) / max;

  const className = classnames('percentage-input', {
    empty: _.isNil(selectedChoice),
  });

  return (
    <div className={className}>
      <Slider
        position={position}
        onAdjust={(percent: number) => {
          handleUpdateSelection(attrKey, percent * max);
        }}
      />

      {!_.isNil(selectedChoice) && (
        <div className="caption">
          <Caption mono>
            {Math.round(selectedChoice)}
            {Math.round(selectedChoice) === Math.round(max) && ' (max)'}
          </Caption>
        </div>
      )}

      <style jsx>{`
        .percentage-input {
          padding: 8px 4px;
        }

        .empty {
          opacity: 0.2;
        }

        .caption {
          background: var(--color-RemoGray01);
          padding: 2px 8px;
          display: inline-block;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
};

export default XYLineInput;
